export enum ReFetchFlag {
  Account = 'account',
  SellBoxes = 'sellBoxes',
  Erc20Approve = 'erc20Approve',
  ClaimAthleteNft = 'claimAthleteNft',
  ClaimMerch = 'claimMerch',
}
